<template>
    <!-- 活动-组队活动-活动列表-添加 -->
    <!-- <el-dialog title="添加组队活动" :visible.sync="show" :before-close="closeDialog" style="width: 80%"> -->
    <el-dialog title="添加组队活动" :visible.sync="show" :before-close="closeDialog" width="50%">
        <!-- 基本信息表单 -->
        <div class="form-box activity">
            <el-form label-width="80px">
                <el-form-item label="活动名称 :" label-width="130px">
                    <el-input v-model="submit_data.name" style="width: 210px"> </el-input>
                </el-form-item>

                <el-form-item label="组队人数 :" label-width="130px">
                    <el-select
                        v-model="submit_data.group_num"
                        placeholder="请选择组队人数"
                        @change="groupNumChange"
                        clearable
                        style="position: relative"
                    >
                        <el-option v-for="item in group_num" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="时效（小时） :" label-width="130px">
                    <el-select v-model="submit_data.hour" placeholder="请选时效" @change="hourChange" clearable style="position: relative">
                        <el-option v-for="item in hour" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关联优惠券:" label-width="130px">
                    <el-select
                        v-model="submit_data.coupon_mode_code"
                        placeholder="请选择优惠券"
                        @visible-change="couponList"
                        @change="couponChange"
                        clearable
                        style="position: relative"
                    >
                        <el-option v-for="item in options_coupon_code" :key="item.value" :label="item.name" :value="item.coupon_mode_code">
                        </el-option>

                        <el-pagination
                            class="pagination"
                            layout="prev, pager, next"
                            :total="selectPages_coupon_data.count"
                            :page-size="coupon_options_data.limit"
                            @current-change="selectPages_coupon_function"
                            :current-page="coupon_options_data.page"
                        />
                    </el-select>
                </el-form-item>
                <!-- 组队次数根据优惠券返回的max_hold_count来显示，比如返回值为1，则组队次数下拉框为1 -->
                <el-form-item label="组队次数:" label-width="130px">
                    <el-select
                        v-model="submit_data.join_num"
                        placeholder="请选择组队次数"
                        @visible-change="joinList"
                        @change="joinChange"
                        clearable
                        style="position: relative"
                    >
                        <el-option v-for="(item, index) in Number(max_hold_count)" :key="item.value" :label="index + 1" :value="index + 1">
                        </el-option>
                    </el-select>
                    <div style="color: #c2c4c9">请先选择关联优惠券，再选择组队次数</div>
                </el-form-item>

                <el-form-item label="限制新老用户 :" label-width="130px">
                    <el-select v-model="submit_data.is_new_consumer" placeholder="请选择">
                        <el-option label="不限制" value="1"> </el-option>
                        <el-option label="限制" value="0"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="双向发放:" label-width="130px">
                    <el-select v-model="submit_data.send_type" placeholder="请选择">
                        <el-option label="双向发放" value="1"> </el-option>
                        <el-option label="不双向发放" value="0"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开关:" label-width="130px">
                    <el-select v-model="submit_data.type" placeholder="请选择">
                        <el-option label="开" value="1"> </el-option>
                        <el-option label="关" value="0"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <div style="display: flex; justify-content: center; margin-top: 20px">
                <!-- <el-button :icon="btnLoading ? 'el-icon-setting' : 'el-icon-loading'" :disabled="!btnLoading" type="primary" @click="addGroupActivitySubmit">保存</el-button>
                 -->
                <submitBtn :data="submit_data" :rules="submit_rules" url="/groupactivity/addGroupActivitySubmit" @onSubmitDig="onSubmitDig">
                    保存
                </submitBtn>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
        }
    },
    data() {
        return {
            show: false,

            group_num: [1, 2, 3, 4, 5, 6, 7, 8],
            hour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
            max_hold_count: '0',
            joinNum: [],

            coupon_options_data: {
                page: 1,
                limit: 5,
                status: '1'
            },
            options_coupon_code: [],
            selectPages_coupon_data: [],

            // 表单提交数据
            submit_data: {
                name: '',
                group_num: '',
                hour: '',
                join_num: '',
                is_new_consumer: '',
                send_type: '',
                type: '',
                coupon_mode_code: ''
            },
            submit_rules: {
                name: {
                    placeholder: '活动名称',
                    rules: {
                        required: true,
                        message: '活动名称为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                group_num: {
                    placeholder: '组队人数',
                    rules: {
                        required: true,
                        message: '组队人数为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                hour: {
                    placeholder: '时效',
                    rules: {
                        required: true,
                        message: '时效为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                coupon_mode_code: {
                    placeholder: '关联优惠券',
                    rules: {
                        required: true,
                        message: '关联优惠券为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                join_num: {
                    placeholder: '组队次数',
                    rules: {
                        required: true,
                        message: '组队次数为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                is_new_consumer: {
                    placeholder: '限制新老用户',
                    rules: {
                        required: true,
                        message: '限制新老用户为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                send_type: {
                    placeholder: '双向发放',
                    rules: {
                        required: true,
                        message: '双向发放为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                type: {
                    placeholder: '开关',
                    rules: {
                        required: true,
                        message: '开关为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 提交按钮
        onSubmitDig() {
            _this.closeDialog();

            _this.$emit('onSubmit');
        },
        groupNumChange(val) {
            _this.submit_data.group_num = val;
        },
        hourChange(val) {
            _this.submit_data.hour = val;
        },
        selectPages_coupon_function(search_data) {
            _this.coupon_options_data.page = search_data;

            _this
                .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                .then((res) => {
                    _this.selectPages_coupon_data = res;
                    _this.options_coupon_code = res.data;
                })
                .catch((err) => {});
        },
        couponList() {
            if (_this.options_coupon_code.length == 0) {
                _this
                    .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                    .then((res) => {
                        _this.selectPages_coupon_data = res;
                        _this.options_coupon_code = res.data;
                    })
                    .catch((err) => {});
            }
        },
        joinList() {
            if (_this.submit_data.coupon_mode_code == '') {
                _this.joinNum = [];
            } else {
                for (let i = 1; i < _this.max_hold_count; i++) {
                    _this.joinNum.push({ value: 'i', label: 'i' });
                }
            }
        },

        couponChange(val) {
            _this.submit_data.coupon_mode_code = val;

            _this.options_coupon_code.forEach((element) => {
                if (element.coupon_mode_code === val) {
                    _this.max_hold_count = element.max_hold_count;

                    console.log(_this.max_hold_count);
                }
            });

            // _this.max_hold_count = _this.options_coupon_code.max_hold_count;
            // console.log(_this.max_hold_count, '_this.max_hold_count');
        },
        joinChange(val) {
            _this.submit_data.join_num = val;
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.joinNum = [];
            _this.max_hold_count = '0';
            _this.submit_data = {
                name: '',
                group_num: '',
                hour: '',
                join_num: '',
                is_new_consumer: '',
                send_type: '',
                type: '',
                coupon_mode_code: ''
            };

            _this.value_coupon_code = '';
        },

        // 提交按钮
        addGroupActivitySubmit() {
            _this
                .$post('/groupactivity/addGroupActivitySubmit', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.$message.success(res.msg);

                    _this.closeDialog();

                    _this.$emit('onSubmit');
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
<style>
.activity .el-input {
    width: 210px;
}
</style>
